import { Modal } from 'antd';
import { userConstants } from '../constants/user.constants.js';
import { getBrandDetailsUrl, getBrandIdUrl } from "../api/urls";
import { SET_TITLE_ID } from "../constants";
import { THEMES } from '../themes';

export const globalActions = {
  getBrandId,
  getBrandDetails,
  setTheme,
};

function setTheme(brandId) {
  return dispatch => {
    const theme = THEMES[brandId];
    if (theme) {
      Object.keys(theme.cssVars).forEach(key => {
        const value = theme.cssVars[key];
        document.documentElement.style.setProperty(key, value);
      });
      dispatch({ type: userConstants.LOY3_SET_BRAND_CONSTANTS, constants: theme.constants });
    }
  };
}

function getBrandId() {
  const url = window.location.origin;
  return dispatch => {
    fetch(`${getBrandIdUrl}?host=${url}`, {
      method: 'GET',
      headers: new Headers({
        'Content-type': 'application/json',
        'Accept': 'application/json',
      })
    }).then(v => v.text())
      .then(brandId => {
        // Setting default
        // localStorage.setItem("_brandId", brandId || '1');
        // dispatch(success(brandId || '1'))
        // FIXME don't commit this
        localStorage.setItem("_brandId", '1');
        dispatch(success( '1'))
      }).catch(err => {
        console.log('Loy3 get brand id request failed', err);
        dispatch(failure(err.message));
      });
  };

  function success(response) {
    return { type: userConstants.LOY3_GET_BRAND_ID_SUCCESS, brandId: response }
  }

  function failure(error) {
    return { type: userConstants.LOY3_GET_BRAND_ID_FAILURE, error }
  }
}

function getBrandDetails(brandId) {
  const brand = brandId || 1;
  const url = `${getBrandDetailsUrl}${brand}`;
  const headers = new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json'});
  return dispatch => {
    fetch(url, {
      method: 'GET',
      headers,
    }).then(v => v.json())
      .then(res => {
        if (res.error) {
          return Promise.reject(res.message);
        }
        const brandDetails = res.responseObj;
        brandDetails['brandCode'] = 'Sandos4U';
        localStorage.setItem("_brand", JSON.stringify(brandDetails));
        dispatch(success(brandDetails))
      }).catch(err => {
        dispatch(failure(err.message));
      });
  };

  function success(response) {
    return { type: userConstants.LOY3_GET_BRAND_SUCCESS, brand: response }
  }

  function failure(error) {
    return { type: userConstants.LOY3_GET_BRAND_FAILURE, error }
  }
}

export const setTitleId = (titleId) => {
  return ({ type: SET_TITLE_ID, titleId });
};

export const showAntModal = ({ title, content }) => {
  Modal.info({
    title,
    content,
  });
};
